<template>
  <div v-if="message || list.length" :class="`alert alert-${variant} d-flex flex-column gap-1`" role="alert">
    <div class="d-flex align-items-start gap-2">
      <i :class="icon" aria-hidden="true"></i>
      <div>
        <strong v-if="title">{{ title }}: </strong>
        <span>{{ message }}</span>
      </div>
    </div>
    <ul class="mb-0 ps-4" v-if="list.length">
      <li v-for="(item, index) in list" :key="`alert-item-${index}`">{{ item }}</li>
    </ul>
  </div>
</template>

<script setup>
/**
 * Muestra el `message` del envelope tal cual lo manda el backend, mas la lista
 * de errores de validacion (422). Nunca se sustituye por un texto generico: el
 * mensaje del servidor es el que explica por que no se cobro.
 */
import { computed } from 'vue'

const props = defineProps({
  message: { type: String, default: '' },
  list: { type: Array, default: () => [] },
  variant: { type: String, default: 'danger' },
  title: { type: String, default: '' }
})

const icon = computed(() => {
  switch (props.variant) {
    case 'success':
      return 'fa-solid fa-circle-check mt-1'
    case 'warning':
      return 'fa-solid fa-triangle-exclamation mt-1'
    case 'info':
      return 'fa-solid fa-circle-info mt-1'
    default:
      return 'fa-solid fa-circle-exclamation mt-1'
  }
})
</script>
